module.exports = __WEBPACK_EXTERNAL_MODULE_19__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 19
// module chunks = 0